<!-- Jquery && Selectric must be provided as a global dep -->
<template>
  <select :name="name" :id="id" >
    <!-- <option value="0">Auswählen</option> -->
    <option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :selected="option.value == selectedValue"
      :disabled="option.disabled"
      :class="option.classes"
    >{{ option.label }}</option>
  </select>
</template>

<script>
import $ from 'jquery';

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
    selectedValue: {
      type: String,
      required: true
    }

  },

  mounted() {
    // selectric
    $(this.$el).selectric();
    
    // update native
    $(this.$el).on('change', (event) => {
      this.dispatchInputEvent(event.target.value);
    });
  },

  methods: {
    dispatchInputEvent(value) {
      this.$emit('input', value, this);
      this.$emit('blur', value, this);
    },

    refresh() {
      $(this.$el).selectric('refresh');
    },

  },
  watch: {
    selectedValue(val) {
      $(this.$el).val(val);
    },
  },
  updated() {
    this.refresh();
  }
};
</script>
